import { createFileRoute, redirect } from '@tanstack/react-router'

/** Legacy Stripe return URL, one hop to the new one; the query string (`order_id`, `session_id`) travels along. */
export const Route = createFileRoute('/_shell/state-tax/success')({
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/state-filings/success', search, replace: true })
  },
})
